export namespace UserPaymentDetailsTypeId {
  export const Pix = 1n;
  export const Imps = 2n;
  export const MexicanBankAccount = 3n;
  export const ArgentineBankAccount = 4n;
  export const SouthAfricaBankAccount = 5n;
  export const NigerianBankAccount = 6n;
  export const Qris = 7n;
  export const SingaporeBankAccount = 8n;
}

export type UserPaymentDetailsTypeIdType =
  (typeof UserPaymentDetailsTypeId)[keyof typeof UserPaymentDetailsTypeId];
